module.exports = __webpack_public_path__ + "ota-facility-icon.adeb8a0163bf83f91319.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ota-facility-icon/fonts/ota-facility-icon.woff?bot94j
// module id = 1376
// module chunks = 24